import Config from 'scoreboard/components/bootslide/bootslide-menu'
import configBackground from '../wob-background-menu'
import WidgetConfigMenu from '../widget-config-menu'
import createInitDataSourceOption from '../create-init-data-source-option'

var InitiativeChartConfig = WidgetConfigMenu.extend({

	typeSpecificTargets: function (hasTemplate) {
		let target = []
		target.push(configBackground(this.model.properties))
		target.push(this.showTitle())
		target.push(createInitDataSourceOption(this.model))
		return target
	},

	showTitle: function() {
		return {
			type: 'toggle',
			label: 'charts.showLabel',
			contentView: Config.ToggleProperty.extend({
				property: {label: 'charts.showLabel', name: 'showLabel'}
			}),
			model: this.model.properties
		}
	}

})

export default InitiativeChartConfig

InitiativeChartConfig.__filename__ = 'dashboards/widgets/initiative-chart/initiative-chart-config.js'
